import ModalOverlay from 'builder/components/ModalOverlay'
import { ButtonV2 } from 'builder/components/Button'
import { useI18n } from 'builder/hooks/useI18n'
import {
  Container,
  CloseIcon,
  CloseIconWrapper,
  ActionWrapper,
  HeaderWrapper,
  Title,
  Description,
} from './styles'

const LOCALIZATION_KEY = 'builder.resume_optimizer.job_posting.leave_modal'

interface Props {
  onLeave: () => void
  onCancel: () => void
}

export const LeaveJobPostingFlowConfirmation = ({ onLeave, onCancel }: Props) => {
  const { i18n } = useI18n()

  return (
    <ModalOverlay overlayFadeDuration={0} contentSlideDuration={300}>
      <Container>
        <CloseIconWrapper onClick={onCancel}>
          <CloseIcon />
        </CloseIconWrapper>
        <HeaderWrapper>
          <Title>{i18n.t(`${LOCALIZATION_KEY}.title`)}</Title>
          <Description>{i18n.t(`${LOCALIZATION_KEY}.description`)}</Description>
        </HeaderWrapper>
        <ActionWrapper>
          <ButtonV2 theme="ghost" onClick={onCancel}>
            {i18n.t(`${LOCALIZATION_KEY}.cancel_button`)}
          </ButtonV2>
          <ButtonV2 onClick={onLeave}>{i18n.t(`${LOCALIZATION_KEY}.leave_button`)}</ButtonV2>
        </ActionWrapper>
      </Container>
    </ModalOverlay>
  )
}
